export default "https://cdn-static.gokick.com/assets/a6d011c942efc1c6cd2854aca00adc3db9e08265/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";